<template lang="pug">
  b-row
    b-col.mb-4.mb-xl-0(
      md='12'
      xl='8')
      b-card.manager-identities-identity-panel.card-white.card-no-gutters.shadow.h-100(no-body)
        b-card-body.d-flex.justify-content-start.align-items-center
          template(v-if='panelShow')
            .panel-picture.mr-4
              b-avatar.wc-bubble.wc-bubble-md.wc-bubble-br.mr-3.shadow(
                :src="$getDeep(panel.rs, 'identifiable.attributes.portrait_url')"
                variant='white'
                alt='')
                template(v-if="!$getDeep(panel.rs, 'identifiable.attributes.portrait_url')" #default)
                  .wc-bubble-content.wc-bubble-linked.bg-primary
                    .i-wrapper
                      i.fal.fa-fw.fa-2x.fa-shield-alt.text-white

            .panel-info
              .panel-info-type.font-weight-bold(v-if='panel.rs.identifiable')
                | {{ $t(`activerecord.models.${$getDeep(panel.rs, 'identifiable.attributes.class_snake')}.one`) }}
              .panel-info-username(v-if='panel.data.attributes.username')
                | @{{ panel.data.attributes.username }}
              .panel-info-identifiable.small.text-muted.text-break(v-if='panel.rs.identifiable')
                | {{ $getDeep(panel.rs, 'identifiable.attributes.identifiable') }}
          template(v-else)
            wc-loaders-heading-avatar
    b-col(
      md='12'
      xl='4')
      b-card.manager-accounts-account-panel.card-white.card-no-gutters.shadow.h-100(no-body)
        b-card-body
          template(v-if='panelShow')
            b-list-group.justify-content-start.p-0.h-100(flush)
              b-list-group-item.border-0(
                :title="$t('activerecord.attributes.shared.updated_at')")
                span.fa-stack.mr-2.text-primary
                  i.fal.fa-circle.fa-stack-2x
                  i.fal.fa-stack-1x.fa-calendar-check
                span
                  | {{ panel.data.attributes.updated_at }}
              b-list-group-item.border-0(
                :title="$t('activerecord.attributes.shared.created_at')")
                span.fa-stack.mr-2.text-primary
                  i.fal.fa-circle.fa-stack-2x
                  i.fal.fa-stack-1x.fa-calendar-plus
                span
                  | {{ panel.data.attributes.created_at }}
          template(v-else)
            wc-loaders-list(:lines='5')
</template>

<script>
import { Panel } from '@common/panel'
import WcLoadersHeadingAvatar from '@components/shared/loaders/WcLoadersHeadingAvatar'
import WcLoadersList from '@components/shared/loaders/WcLoadersList'

export default {
  name: 'manager-identities-identity-panel',
  mixins: [Panel],
  components: {
    WcLoadersHeadingAvatar,
    WcLoadersList,
  },
  watch: {
    panel() {
      this.panel.rs.identifiable = this.panelDataIncluded(
        this.$getDeep(this.panel.data, 'relationships.identifiable.data.type'),
        this.$getDeep(this.panel.data, 'relationships.identifiable.data.id')
      )
    },
  },
  data() {
    return {
      cacheType: 'manager/identities/getPanel',
      cachePayload: { id: this.$route.params.identity_id },
    }
  },
}
</script>
